import React from 'react';
import I18n from 'i18n-js';

import SanitizedRender from '../../components/sanitized_render';

export interface IProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
}

export default class CMSBuyingGuidePageHead extends React.Component<IProps, null> {
  getBackgroundImageStyle() {
    if (!this.props.imageUrl) { return null; }

    return {
      style: { backgroundImage: `url('${this.props.imageUrl}')` },
    };
  }

  renderHeadings() {
    if (!this.props.title) return null;

    return (
      <header className="cms-buying-guide-page-head__text">
        <h1>
          <SanitizedRender
            className="cms-buying-guide-page-head__title"
            html={this.props.title}
            inlineTagsOnly
          />
          <small className="cms-buying-guide-page-head__label">
            {I18n.t('cms.buyingGuideLabel')}
          </small>
        </h1>
        {this.props.subtitle &&
          <SanitizedRender
            htmlTag="h2"
            className="cms-buying-guide-page-head__subtitle"
            html={this.props.subtitle}
            inlineTagsOnly
          />
        }
      </header>
    );
  }

  render() {
    return (
      <div className="cms-buying-guide-page-head">
        <div
          className="cms-buying-guide-page-head__image"
          {...this.getBackgroundImageStyle()}
        />
        <div className="cms-buying-guide-page-head__wrapper">
          <div className="cms-buying-guide-page-head__content">
            {this.renderHeadings()}
          </div>
        </div>
      </div>
    );
  }
}
